import React, { useState } from "react";

import { observer } from "mobx-react";
import styled, { keyframes } from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import Video from "../../shared/components/Video/Video";
import PlayButton from "./PlayButton";
import StyledRoleLink from "./StyledRoleLink";

const StyledOverlay = styled.div`
  opacity: ${({ isPaused }) => (isPaused ? 1 : 0)};
  position: absolute;
  color: #fff;
  background-color: ${({ theme }) => theme.footerBackgroundColor};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
`;

const fadeIn = keyframes`
  from {opacity: 0}
  to { opacity: 1}
`;

const StyledMobileRoleBrowser = styled.div`
  animation: ${fadeIn};
  animation-duration: 0.3s;
  animation-iteration-count: 1;
  position: absolute;
`;

const StyledRolesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0 0;
  background: #fff;

  a {
    display: block;
  }
`;

function MobileRoleBrowser() {
  const { rolesStore } = useStores();
  const { roles } = rolesStore;

  return (
    <StyledMobileRoleBrowser className="d-flex flex-column h-100">
      <StyledRolesGrid className="flex-grow-1">
        {roles.map((role) => (
          <StyledRoleLink
            key={role.slug}
            className="p-3 d-flex align-items-center justify-content-center"
            href={`/roles/${role.slug}`}
          >
            {role.roleName}
          </StyledRoleLink>
        ))}
      </StyledRolesGrid>
    </StyledMobileRoleBrowser>
  );
}

function MobileHomepage() {
  const [isPaused, setIsPaused] = useState(true);
  const { homepageStore } = useStores();

  const { mobileVimeoId } = homepageStore;

  const timeToStop = 14;

  return (
    mobileVimeoId && (
      <Video
        controls={false}
        endVideoView={<MobileRoleBrowser />}
        isPaused={isPaused}
        timeToStop={timeToStop}
        vimeoID={mobileVimeoId}
      >
        <StyledOverlay
          className="d-flex align-items-center justify-content-center flex-column"
          isPaused={isPaused}
          onTouchStart={() => setIsPaused(!isPaused)}
        >
          <div className="d-flex flex-column align-items-center justify-content-center">
            <h1 className="my-5 text-center">
              WELCOME TO GAILS
              <br />
              TAKE A LOOK AROUND
            </h1>
          </div>
          <PlayButton />
          <h6 className="py-5">PUT YOUR HEADPHONES ON</h6>
        </StyledOverlay>
      </Video>
    )
  );
}
export default observer(MobileHomepage);
